// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".d542e019eee91911a068ec1185239ea139781af1.chunk.bundle.js";
};